module.exports = __webpack_public_path__ + "static/media/close-modal.a4ce1849.svg";